import { Divider, Option, Select } from '@mui/joy';

import { partition } from 'lodash-es';
import { FC } from 'react';

import { EMessageType } from './types';

type TProps = {
  hideMessageTypeSwitch: boolean;
  readOnly: boolean;
  messageType: EMessageType;
  messageRole: string | undefined;
  onChange: (value: EMessageType | undefined) => void;
  isTemplate: boolean;
  disabledMessageTypes?: EMessageType[];
};

const MessageType: FC<TProps> = ({
  hideMessageTypeSwitch,
  readOnly,
  messageType,
  messageRole,
  onChange,
  isTemplate,
  disabledMessageTypes,
}) => {
  if (hideMessageTypeSwitch) {
    return <div></div>;
  }
  if (readOnly) {
    return (
      <div className="text-sm font-semibold uppercase text-tertiary">
        {messageType}
        {messageType === EMessageType.CHAT && ` (${messageRole ?? ''})`}
      </div>
    );
  }

  const renderOptions = () => {
    const [firstOptions, secondOptions] = partition(
      Object.values(EMessageType),
      (type) => type !== EMessageType.CHAT && type !== EMessageType.PLACEHOLDER
    );

    const renderOption = (type: EMessageType) => {
      const displayName = type === EMessageType.AI ? 'AI' : type;
      return (
        <Option key={type} value={type} className="capitalize">
          {displayName}
        </Option>
      );
    };

    return (
      <>
        {firstOptions
          .filter((type) => !disabledMessageTypes?.includes(type))
          .map(renderOption)}
        {secondOptions.length > 0 && <Divider />}
        {secondOptions
          .filter((type) => !disabledMessageTypes?.includes(type))
          .map((type) => {
            if (type === EMessageType.PLACEHOLDER && !isTemplate) return null;
            return renderOption(type);
          })}
      </>
    );
  };
  return (
    <Select
      value={messageType}
      onChange={(_, value) => onChange(value ?? undefined)}
      slotProps={{
        root: {
          sx: {
            width: 'unset',
            backgroundColor: 'transparent',
            border: 'none',
            padding: 0,
            paddingLeft: '8px',
            paddingRight: '8px',
            minHeight: 32,
            fontSize: 'xs',
            marginLeft: '-8px',
            marginTop: '-4px',
            marginBottom: '-4px',
          },
        },
        button: {
          sx: (theme) => ({
            color: theme.vars.palette.neutral[500],
            fontWeight: 600,
            textTransform: 'uppercase',
          }),
        },
      }}
    >
      {renderOptions()}
    </Select>
  );
};

export default MessageType;
